import type { Label, LabelType } from '@/types/gql.generated';
import { createContext, createContextHook } from '@/utils';
import type { QueryError } from '@/utils/errors';

type CreateCallbacks = {
  onSuccess?: () => void;
  onError?: () => void;
};

type UpdateCallbacks = {
  onError?: () => void;
};

type RemoveCallbacks = {
  onSuccess?: () => void;
  onError?: (error: QueryError) => void;
};

/**
 * Supplies the label catalog and CRUD operations to the shared label
 * components. Schedules and Experiences each provide their own implementation
 * (ScheduleLabelDataProvider / LabelProvider) so the presentational components
 * remain agnostic to the underlying API.
 */
export type LabelData = {
  labelType: LabelType;
  labels: Label[];
  createLabel: (label: Label, options?: CreateCallbacks) => void;
  isCreatePending: boolean;
  updateLabel: (
    labelId: string,
    text: string,
    options?: UpdateCallbacks
  ) => void;
  removeLabel: (labelId: string, options?: RemoveCallbacks) => void;
  updateSortOrder: (labels: Label[]) => void;
};

export const LabelDataContext = createContext<LabelData | undefined>(
  undefined,
  'LabelDataContext'
);

export const useLabelData = createContextHook(LabelDataContext);
